var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-picker__wrapper"},[_c('input',{staticClass:"minicolors",attrs:{"id":_vm.inputid},domProps:{"value":_vm.initialColor}})])}
var staticRenderFns = []

export { render, staticRenderFns }